import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { apiDashboard } from 'helpers/decorators/api'
import EditProfileAssessor from './EditProfileAssessor'
import EditProfileParticipant from './EditProfileParticipant'

@apiDashboard.apiPersons({
    loadProfile: true,
    isAssessor: true,
})
class EditProfile extends Component {
  static propTypes = {
    isAssessor: PropTypes.boolean,
  }

  render() {
    return (
      this.props.isAssessor ? <EditProfileAssessor {...this.props} /> : <EditProfileParticipant {...this.props} />
    )
  }
}

export default EditProfile
